module.exports = __webpack_public_path__ + "img/phone1.03a546e.png";